import { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface EditFileFormProps {
  file: { id: number; name: string };
  onSave: (fileId: number, newName: string) => void;
  onCancel: () => void;
}

export const EditFileForm = ({ file, onSave, onCancel }: EditFileFormProps) => {
  const [name, setName] = useState(file.name);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(file.id, name);
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 border-t">
      <div className="flex items-center gap-4">
        <Input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="flex-grow"
        />
        <div className="flex gap-2">
          <Button type="submit">Mentés</Button>
          <Button type="button" variant="outline" onClick={onCancel}>Mégse</Button>
        </div>
      </div>
    </form>
  );
};
